export default __webpack_public_path__ + "static/media/boxing.e963064f.gif";